/* Canva (brightivity.dev/canva — worker brightivity-canva; same Canva links as StudioCore). */
import { API_BASE } from '../config.js';
import { api, getSession } from './client.js';

export const listAccounts = () => api('/canva/accounts');
export const useAccount = (id) => api('/canva/accounts/use', { method: 'POST', body: { id } });
export const signOutAccount = (id) => api('/canva/accounts/sign-out', { method: 'POST', body: { id } });
export const removeAccount = (id) => api('/canva/accounts/remove', { method: 'POST', body: { id } });
/** Start Canva sign-in; the browser then goes to Canva and comes back to `returnTo` with ?canva=linked|error. */
export const linkStart = (returnTo) => api('/canva/link-start', { method: 'POST', body: { returnTo } });

export function listDesigns({ account, continuation, query, ownership, sortBy } = {}) {
  const q = new URLSearchParams();
  if (account) q.set('account', account);
  if (continuation) q.set('continuation', continuation);
  if (query) q.set('query', query);
  if (ownership && ownership !== 'any') q.set('ownership', ownership);
  if (sortBy && sortBy !== 'relevance') q.set('sort_by', sortBy);
  return api(`/canva/designs?${q.toString()}`);
}
export const startExport = (account, designId, format, pages) => api('/canva/export', { method: 'POST', body: { account, design_id: designId, format, ...(pages && pages.length ? { pages } : {}) } });
export const exportStatus = (account, job) => api(`/canva/export/${encodeURIComponent(job)}?account=${encodeURIComponent(account)}`);

/** Export a design and wait for it (Canva takes a few seconds per page). → {ok, files: Blob[]} */
export async function exportDesign(account, designId, format = 'png', pages, onTick) {
  const st = await startExport(account, designId, format, pages);
  if (!st.ok) return { ok: false, error: st.error, needsRelink: st.data && st.data.needsRelink };
  const job = st.data.job_id;
  for (let i = 0; i < 60; i++) {
    await new Promise((r) => setTimeout(r, i < 3 ? 1500 : 2500));
    onTick && onTick(i);
    const s = await exportStatus(account, job);
    if (!s.ok) return { ok: false, error: s.error };
    if (s.data.status === 'failed') return { ok: false, error: s.data.error || 'Canva could not export this design.' };
    if (s.data.status === 'success') {
      const files = [];
      const auth = { Authorization: `Bearer ${getSession() && getSession().token}` };
      for (let n = 0; n < s.data.files; n++) {
        const res = await fetch(`${API_BASE}/canva/export/${encodeURIComponent(job)}/file/${n}?account=${encodeURIComponent(account)}`, { headers: auth });
        if (!res.ok) return { ok: false, error: `Page ${n + 1} could not be downloaded (${res.status}).` };
        files.push(await res.blob());
      }
      return { ok: true, files };
    }
  }
  return { ok: false, error: 'Canva is taking too long to export this design. Try again.' };
}
